import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ContextMenuItemState } from "../ContextMenuItemState";
import { ContextMenuItemStateCommand } from "../ContextMenuItemStateCommand";
import { ContextMenuItemStateCommandCriteria } from "../ContextMenuItemStateCommandCriteria";
import { BfxBlotterAction } from "../bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterOrdersContextMenuState } from "./BfxBlotterOrdersContextMenuState";
import { BfxBlotterOrdersContextMenuItem } from "shared/cubiq-services/model/contextmenu/bfx-blotter-orders/BfxBlotterOrdersContextMenuItem";

export class BfxBlotterOrdersContextMenuFillNowItem extends BfxBlotterOrdersContextMenuItem {
  constructor() {
    super(
      BfxBlotterAction.ACTION_ORDER_FILL_NOW,
      "Fill Now",
      BfxBlotterOrdersContextMenuFillNowItem.checkAvailableFn(),
      BfxBlotterOrdersContextMenuFillNowItem.checkEnabledFn(),
      ContextMenuItemStateCommandCriteria.Item,
      ContextMenuItemStateCommandCriteria.Item,
    );
  }

  private static checkAvailableFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item: CubiqTS.OrderDataImpl,
    ) {
      let orderType = item?.orderType;
      let isAlgo =
        orderType != null
          ? orderType === CubiqTS.OrderType.ALGO || orderType === CubiqTS.OrderType.BMALGO
          : true;
      itemState.available = isAlgo && menuState.canFillNow;
    };
  }

  /**
   * note- itemState.enabled starts off false
   */
  private static checkEnabledFn(): ContextMenuItemStateCommand<CubiqTS.OrderDataImpl> {
    return function (
      this: void,
      menuState: BfxBlotterOrdersContextMenuState,
      itemState: ContextMenuItemState,
      item: CubiqTS.OrderDataImpl,
    ) {
      if (!item || menuState.count !== 1) {
        return;
      }

      // if this is not an Algo order
      if (
        item.requestedOrderType !== CubiqTS.RequestOrderType.ALGO &&
        item.requestedOrderType !== CubiqTS.RequestOrderType.BMALGO
      ) {
        return;
      }

      // item is not with external trader group supporting fillnow
      if (item.deskId != null) {
        let tradingGroup = menuState.traderGroups.get(item.deskId.toString());

        if (!tradingGroup || !tradingGroup.fillNowFg) {
          return;
        }
      } else {
        return;
      }

      // Make sure user is permissioned
      if (item.entryUserCode !== menuState.activeUser.userCode) {
        if (menuState.activeUser.isTrader()) {
          if (!menuState.activeUser.tradingGroupsIdSet.has(item.deskId.toString())) {
            return;
          }
        } else if (menuState.activeUser.isSales()) {
          if (
            !item.salesGroupId ||
            !menuState.activeUser.salesGroupsIdSet.has(item.salesGroupId.toString())
          ) {
            return;
          }
        }
      }

      // Order is not locked - will be undefined if not locked
      if (item.lockType != null) {
        return;
      }
      // Order is not working (rignorting pause state)
      if (
        item.orderState !== CubiqTS.OrderState.ACTIVE &&
        item.orderState !== CubiqTS.OrderState.PENDING
      ) {
        return;
      }

      // Order is not in a pausepending state
      if (
        item.pauseState === CubiqTS.PauseState.PAUSE_PENDING ||
        item.pauseState === CubiqTS.PauseState.RESUME_PENDING
      ) {
        return;
      }
      itemState.enabled = true;
    };
  }

  public static get state(): any {
    return new ContextMenuItemState();
  }
}
